import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "initialView", "form", "backBtn", "autosubmitUserId", "btnSubmit" ]

  initialize() {
    if (this.autosubmitUserIdTarget.value) {
      // this.element.requestSubmit()
      this.btnSubmitTarget.click()
    }
  }

  showForm(e) {
    e.preventDefault()

    this.initialViewTarget.style.display = 'none'
    this.formTarget.style.display = 'block'
    this.backBtnTarget.style.display = 'block'
  }

  showInitialView(e) {
    e.preventDefault()

    this.initialViewTarget.style.display = 'block'
    this.formTarget.style.display = 'none'
    this.backBtnTarget.style.display = 'none'
  }
}
